module.exports = __webpack_public_path__ + "static/media/broken-clouds.f1fba5bd.png";